export default {
    layout: null,
    react_layout: {
        template_name: null,
        layouts: {}
    },
    scope: null,
    templates: [],
    scopes: [],
    blocks: [],
    busy: false
};
